import {SQFT_FEATURES} from "../constants";

export const HIGHLIGHT_LINE_RESOURCE = [
  SQFT_FEATURES.top_handle,
  SQFT_FEATURES.bottom_handle,
  SQFT_FEATURES.handle,
];
